import { Progress, Card, Row, Col } from 'antd'
import Logs from '../Logs'
import { downloadFile } from 'Services/WeaverUtils'
import moment from 'moment'
import { useState, useEffect } from 'react';
import { store } from '~/Store';

const statusMap = {
  'running': 'active',
  'pending': 'normal',
  'errored': 'exception',
  'success': 'success'
}

const getColor = (status) => {
  if (status === 'success') {
    return '#52c41a'
  } else if (status === 'errored') {
    return '#eb3c3c'
  }
}

const Description = ({ orchestrator, started, stopped, status, uid, inputFileId, resultFileId }) => {
  const [inputFile, setInputFile] = useState(null);
  const [inputFileLoading, setInputFileLoading] = useState(false);
  const [resultFile, setResultFile] = useState(null);
  const [resultFileLoading, setResultFileLoading] = useState(false);

  useEffect(() => {
    const fetchInputFile = async () => {
      if (inputFileId) {
        setInputFileLoading(true);
        try {
          const file = await Weaver.File.load(inputFileId);
          setInputFile(file);
        } catch (error) {
          console.error('Error loading input file:', error);
        } finally {
          setInputFileLoading(false);
        }
      }
    };

    fetchInputFile();
  }, [inputFileId]);

  useEffect(() => {
    const fetchResultFile = async () => {
      if (resultFileId) {
        setResultFileLoading(true);
        try {
          const file = await Weaver.File.load(resultFileId);
          setResultFile(file);
        } catch (error) {
          console.error('Error loading result file:', error);
        } finally {
          setResultFileLoading(false);
        }
      }
    };

    fetchResultFile();
  }, [resultFileId]);

  const renderDownloadLink = (fileId, file) => {
    return (
      <Col span={12}>
        <a onClick={() => downloadFile(fileId)}>Download {file.name()}</a>
      </Col>
    );
  };

  const renderStopped = () => (
    <>
      <Col span={12}>Stopped: {stopped}</Col>
      {(!resultFileLoading && !_.isEmpty(resultFile)) ? renderDownloadLink(resultFileId, resultFile) : null}
    </>
  );

  return (
    <div>
      <Row>
        <Col span={12}>Status: {_.startCase(status)}</Col>
        <Col span={12}><Logs orchestrator={orchestrator} uid={uid} /></Col>
      </Row>
      <Row>
        <Col span={12}>Started: {started}</Col>
        <Col span={12}>
          {(!inputFileLoading && !_.isEmpty(inputFile)) ? renderDownloadLink(inputFileId, inputFile) : null}
        </Col>
      </Row>
      <Row>
        {stopped !== '-' ? renderStopped() : ' '}
      </Row>
    </div>
  );
};

// TODO: Add Duration
export default function ({ job }) {
  const orchestrator = store.getState().explore.plugins['weaver-orchestrator'];

  const { uid, started, stopped, resultFileId, inputFileId, progress = 0, status = "pending" } = job;

  return (
    <Card
      key={uid}
      style={{ width: '100%', margin: '20px 0px' }}
    >
      <Card.Meta
        className="job-description-tile"
        avatar={
          <Progress
            type="circle"
            status={statusMap[status]}
            percent={progress}
            style={{ color: `${getColor(status)}` }}
            size="small"
            width={50}
          />
        }
        description={
          <Description
            orchestrator={orchestrator}
            started={started ? moment.utc(started, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("ddd, DD MMM YYYY, HH:mm") : '-'}
            stopped={stopped ? moment.utc(stopped, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("ddd, DD MMM YYYY, HH:mm") : '-'}
            status={status}
            uid={uid}
            resultFileId={resultFileId}
            inputFileId={inputFileId}
          />
        }
      />
    </Card>
  )
}
